var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ic-form__connection" },
    [
      _c("h3", [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _vm.selected
        ? _c("div", { staticClass: "panel" }, [
            _c("p", [
              _vm._v("Wybrano połączenie: "),
              _c("br"),
              _vm._v(" "),
              _c("b", [_vm._v(_vm._s(_vm.value.departureStationName))]),
              _vm._v(" -> "),
              _c("b", [_vm._v(_vm._s(_vm.value.arrivalStationName))]),
              _vm._v(
                ", " +
                  _vm._s(_vm.value.departureDate) +
                  " " +
                  _vm._s(_vm.value.departureTime) +
                  ", " +
                  _vm._s(_vm.value.trainNo) +
                  "\n"
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("IcFormRowWrapper", {
        attrs: {
          rowElement: "IcFormRow",
          id: "isSelected",
          name: _vm.name + ".isSelected",
          aria: _vm.$t("aria_required"),
          label: "",
          labelWidth: 4,
          controlWidth: 8,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ validator }) {
              return [
                _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "button",
                        "data-bs-toggle": "modal",
                        "data-bs-target":
                          "#" + _vm.name + "selectConnectionModal",
                      },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.value.isSelected
                              ? _vm.$t("label_zmien_polaczenie")
                              : _vm.$t("label_wybierz_polaczenie")
                          ) +
                          "\n              "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._v("\n              " + _vm._s(_vm.v) + "\n            "),
                ]),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: _vm.name + "selectConnectionModal",
            tabindex: "-1",
            "data-bs-backdrop": "static",
            "data-bs-keyboard": "false",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered modal-lg",
              class: _vm.hasResults,
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", [_vm._v("Wyszukaj połączenie")]),
                  _vm._v(" "),
                  _c("button", {
                    ref: "Close",
                    staticClass: "btn-close",
                    attrs: {
                      type: "button",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _c("IcFormRowWrapper", {
                          attrs: {
                            rowElement: "IcFormRow",
                            id: "departureStation",
                            name: _vm.name + ".departureStation",
                            aria: _vm.$t("aria_required"),
                            label: _vm.$t("label_departureStation"),
                            labelWidth: 4,
                            controlWidth: 8,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ validator }) {
                                return [
                                  _c("IcStationTypeahead", {
                                    attrs: {
                                      id: "departureStation",
                                      valueField: "h",
                                      noMeta: 1,
                                      icStation: -1,
                                      disabled: _vm.inProgress,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.emitInput(
                                          _vm.data,
                                          validator
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.data.departureStation,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "departureStation",
                                          $$v
                                        )
                                      },
                                      expression: "data.departureStation",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _c("IcFormRowWrapper", {
                          attrs: {
                            rowElement: "IcFormRow",
                            id: "arrivalStation",
                            name: _vm.name + ".arrivalStation",
                            aria: _vm.$t("aria_required"),
                            label: _vm.$t("label_arrivalStation"),
                            labelWidth: 4,
                            controlWidth: 8,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ validator }) {
                                return [
                                  _c("IcStationTypeahead", {
                                    attrs: {
                                      id: "arrivalStation",
                                      valueField: "h",
                                      noMeta: 1,
                                      icStation: -1,
                                      disabled: _vm.inProgress,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.emitInput(
                                          _vm.data,
                                          validator
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.data.arrivalStation,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "arrivalStation",
                                          $$v
                                        )
                                      },
                                      expression: "data.arrivalStation",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("IcFormRowWrapper", {
                          attrs: {
                            rowElement: "IcFormRow",
                            id: "departureDate",
                            name: _vm.name + ".departureDate",
                            aria: _vm.$t("aria_required_date"),
                            label: _vm.$t("label_departureDate"),
                            labelWidth: 4,
                            controlWidth: 8,
                            disabled: _vm.inProgress,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ validator }) {
                                return [
                                  _c("ic-date-picker", {
                                    attrs: {
                                      id: "departureDate",
                                      minDate: _vm.minDate,
                                      endDate: _vm.endDate,
                                      title: "",
                                      disabled: _vm.inProgress,
                                      aria: "Strzałka w górę dół, następny poprzedni dzień.",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.emitInput(
                                          _vm.data,
                                          validator
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.data.departureDate,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.data, "departureDate", $$v)
                                      },
                                      expression: "data.departureDate",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-2 form-padding-left" },
                      [
                        _c("IcFormRowWrapper", {
                          attrs: {
                            rowElement: "IcFormRow",
                            id: "departureTime",
                            name: _vm.name + ".departureTime",
                            aria: _vm.$t("aria_required_time"),
                            label: _vm.$t("label_departureTime"),
                            labelWidth: 4,
                            controlWidth: 8,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ validator }) {
                                return [
                                  _c("IcTimePicker", {
                                    attrs: {
                                      id: "departureTime",
                                      disabled: _vm.inProgress,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.emitInput(
                                          _vm.data,
                                          validator
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.data.departureTime,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.data, "departureTime", $$v)
                                      },
                                      expression: "data.departureTime",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary mt-4",
                          attrs: {
                            disabled:
                              _vm.inProgress ||
                              !_vm.data.arrivalStation ||
                              !_vm.data.departureStation ||
                              !_vm.data.departureDate ||
                              !_vm.data.departureTime,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.searchConnection.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.inProgress
                                ? _vm.$t("label_czekaj")
                                : _vm.$t("label_szukaj")
                            )
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.hasResults
                    ? _c(
                        "div",
                        { staticClass: "mt-5", attrs: { id: "connections" } },
                        _vm._l(_vm.connections, function (item) {
                          return _c(
                            "div",
                            {
                              key: item.id,
                              staticClass: "itinerary itinerary-promo mb-3",
                            },
                            [
                              _c("div", { staticClass: "itinerarySummary" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "itinerarySummary__destinations",
                                  },
                                  [
                                    _c("div", { staticClass: "row gy-5" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 col-xl-10 d-flex align-items-center justify-content-start ps-5",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "itinerarySummary__destination itinerarySummary__destination--start",
                                            },
                                            [
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  { staticClass: "city" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.departure.name
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "time" },
                                                  [
                                                    _vm._v(
                                                      "\n                 " +
                                                        _vm._s(
                                                          _vm.moment
                                                            .utc(
                                                              item.departure
                                                                .date * 1000
                                                            )
                                                            .format("HH:mm")
                                                        ) +
                                                        "                "
                                                    ),
                                                    _c("small", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.moment
                                                            .utc(
                                                              item.departure
                                                                .date * 1000
                                                            )
                                                            .format(
                                                              "YYYY-MM-DD"
                                                            )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "itinerarySummary__number",
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    _vm.moment
                                                      .utc(item.duration * 1000)
                                                      .format("HH:mm")
                                                  ) +
                                                  "\n              "
                                              ),
                                              _c("hr"),
                                              _vm._v(" "),
                                              _c("small", [
                                                _vm._v(
                                                  _vm._s(
                                                    item.sections[0].train.name
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "itinerarySummary__destination itinerarySummary__destination--end",
                                            },
                                            [
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  { staticClass: "city" },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          item.arrival.name
                                                        ) +
                                                        "              "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "time" },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.moment
                                                            .utc(
                                                              item.arrival
                                                                .date * 1000
                                                            )
                                                            .format("HH:mm")
                                                        ) +
                                                        "                "
                                                    ),
                                                    _c("small", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.moment
                                                            .utc(
                                                              item.arrival
                                                                .date * 1000
                                                            )
                                                            .format(
                                                              "YYYY-MM-DD"
                                                            )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 col-xl-2 d-flex align-items-center justify-content-xl-end justify-content-center",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "itinerarySummary__button-std order-1 order-xl-3 mx-2",
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-warning",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.selectConnection(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("wybierz"))
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.searchErrors.length
                    ? _c(
                        "div",
                        { staticClass: "alert alert-danger mt-4" },
                        _vm._l(_vm.searchErrors, function (error) {
                          return _c("span", { key: error.id }, [
                            _vm._v("\n        " + _vm._s(error) + "\n      "),
                          ])
                        }),
                        0
                      )
                    : _vm._e(),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }